import { AsyncPipe, DatePipe, NgFor, NgIf, TitleCasePipe, CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChange, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { PermissionsService } from 'app/modules/admin/apps/file-manager/permissions/permissions.service';
import { Permission } from 'app/modules/admin/apps/file-manager/permissions/permissions.types';
import { DateTime } from 'luxon';
import { Observable } from 'rxjs';
import { Item } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FileManagerComponent } from '../file-manager.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from 'app/services/document.service';
import { EventService } from 'app/services/event.service';
import { SharedPopoupComponent } from 'app/shared-component/shared-popoup/shared-popoup.component';
import { NgxLoadingModule } from 'ngx-loading';
import { accessLevel, menuLabels } from 'app/shared/global-constants'
import { Asset } from 'app/models/document';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssetAccess } from 'app/models/asset-access';
import { Util } from 'app/models/util';
import { DomSanitizer } from '@angular/platform-browser';
import { Confirm } from 'app/shared/popup';
import { CUSTOM_THEME_ELEMENTS_CLASSES } from 'app/constants';
import { FullNamePipe, getFullName } from '@fuse/pipes/full-name.pipe';
import { ActionDirective } from '@fuse/directives/action.directive';

@Component({
    selector: 'permissions-component',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    //changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MatIconModule,
        RouterLink,
        AsyncPipe,
        TitleCasePipe,
        DatePipe,
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        MatRippleModule,
        MatInputModule,
        MatSelectModule,
        NgClass,
        FileManagerComponent,
        NgxLoadingModule,
        FormsModule,
        ReactiveFormsModule,
        FullNamePipe,
        ActionDirective,

    ],
})
export class PermissionsComponent implements OnInit {
    @Input() asset : Asset = null;
    members: any[];
    roles = accessLevel;
    menuLabels = menuLabels;
    isLoading: boolean = false;
    public peopleAccess: AssetAccess[] = [];
    isViewer:boolean=false
    teamDecorator={}
    WebInputParams = this.util.getWebComponentInputParams(); 

    /**
     * Constructor
     */
    constructor(
        public _permissionsService: PermissionsService,
        public _fileManagerComponent: FileManagerComponent,
        public ToastrService: ToastrService,
        private _matDialog: MatDialog,
        public docService: DocumentService,
        public eventSer: EventService,
        public util: Util,
        public sanitizer: DomSanitizer,
        private confirm: Confirm,
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        if(this.asset && this.asset.id){
            if (this.asset.accessLevel=='VIEWER') {
                this.isViewer = true
            }
            this.fetchAccess();
        } else 
            this.asset = new Asset();

        this.eventSer.getGlobalData.subscribe((data) => {
            if (data == 'share' && this.asset.id)
                this.fetchAccess();
        })
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
		for (let propName in changes) {
			let changedProp = changes[propName];
			let to = changedProp.currentValue; //JSON.stringify();
			if (changedProp.isFirstChange()) {
			} else {
				let from = JSON.stringify(changedProp.previousValue);
				if (`${propName}` == `asset`) {
					this.asset = to;
                    this.fetchAccess();
				}
			}
		}
	}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Returns whether the given dates are different days
     *
     * @param current
     * @param compare
     */
    isSameDay(current: string, compare: string): boolean {
        return DateTime.fromISO(current).hasSame(DateTime.fromISO(compare), 'day');
    }

    /**
     * Get the relative format of the given date
     *
     * @param date
     */
    getRelativeFormat(date: string): string {
        return DateTime.fromISO(date).toRelativeCalendar();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    fetchAccess() {
        this.isLoading = true;
        this.docService.getAccess(this.asset.id).then((res) => {
            this.peopleAccess = this.docService.getData(res);
            this.renderTeamMembers()
            this.isLoading = false;
        }).catch((error) => {
            this.isLoading = false,
            console.log(error);
        })
    }

    change(item) {
      this.update(item);
    }
   
    update(data) {
      let level = new AssetAccess();
      level = {...data,userIds:[]}
      level.userIds.push(level.user.id);
        this.isLoading = true;
        this.docService.updateAccess(level).then((res) => {
            this.ToastrService.info("Access grant applied");
            this.isLoading = false;
        }).catch((error) => {
            this.isLoading = false;
            console.log(error);
        })
    }

    deleteAccess(id, index){
        const dialogRef = this.confirm.openPopup("Are you sure you want to remove this access?", "warning", "Remove Access");
        dialogRef.afterClosed().subscribe((result) => {

             if (result === 'confirmed') {
                this.isLoading = true;
                this.docService.deleteAccess(id).then((res) => {
                    this.peopleAccess.splice(index, 1);
                    this.isLoading = false;
                    this.ToastrService.warning("Access restriction applied");
                }).catch((error)=>{
                    this.isLoading = false;
                    console.log(error);
                }) 
              } 
   });

    }

    renderTeamMembers() {
        this.peopleAccess.forEach((member: AssetAccess) => {
            member["innerDiv"] = "";

            if (member.user.profilePic) {
                member["innerDiv"] += `<img
                class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
                src="${member.user.profilePic}"
                [alt]="'Member Image'">`;
            } else {
                const name = getFullName(member.user).toUpperCase();
                const dec_class = this.util.getUserColor(name);
                const [first, last] = name.split(" ");

                const initials = `${first?.substring(0, 1) || ''}${last?.substring(0, 1) || ''}`;
                this.teamDecorator[name] = initials;

                member["innerDiv"] += `<div class="${dec_class} flex shrink-0 items-center justify-center w-10 h-10 mr-4 rounded-full font-10">
                    ${this.teamDecorator[name]}
                </div>`;
            }
        });
    }
}
